import { getText } from '../../helpers';

const TEXT_BASE_PATH = 'pages.solution.demos.kenshoNerd';

export default function getTranslatedText(path: string): string {
    return getText(`${TEXT_BASE_PATH}.${path}`);
}
